module.exports = __webpack_public_path__ + "img/login_bg.45470a86.png";